<template>
  <tip-tap-editor-component :model-value="modelValue" :blocks="blocks" :brand-color="brandColor" @update:modelValue="$emit('update:modelValue', $event)" />
</template>

<script>
import TipTapEditorComponent from '@/components/editor/TipTapEditorComponent'

export default {
  name: 'ArticleEditorComponent',

  components: {
    TipTapEditorComponent,
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    config: {
      default: function () {
        return {}
      },
      type: Object,
    },
    blocks: {
      type: Boolean,
      default: false,
    },
    brandColor: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue'],
}
</script>